import { loadProtomapsLeaflet } from '../../utils/loadProtomapsLeaflet';

const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors ' +
  '&copy; <a href="https://protomaps.com" target="_blank">Protomaps</a>';

export async function createOsmBaseMaps(pmtilesUrl) {
  if (!pmtilesUrl) {
    throw new Error('OSM PMTiles URL missing from runtime map config');
  }

  const protomapsL = await loadProtomapsLeaflet();
  // Protomaps label rules key off a 2-letter language code (e.g. "name:en"),
  // so strip any region suffix from navigator.language ("en-US" -> "en").
  const lang = (navigator.language || 'en').split('-')[0];
  const layer = protomapsL.leafletLayer({
    url: pmtilesUrl,
    flavor: 'light',
    lang,
  });

  Object.assign(layer.options, {
    attribution: OSM_ATTRIBUTION,
    displayLabel: 'Map',
  });

  return { Map: layer };
}
